module.exports = __webpack_public_path__ + "static/media/church.7e4ced3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/church.png
// module id = 334
// module chunks = 0